export default __webpack_public_path__ + "85cf6124b50493357ea69eac9838361e.png";